module.exports = __webpack_public_path__ + "static/treatmentTable-46268de8d3ff01df4dfbcf61f901654f.png";